import { html } from 'htm/preact';
import Eyebrow from './Eyebrow';

const Header = ({ title, description, descriptionSecondary, eyebrow, children, isError, isNormalCase }) => {
  return html`
    <div class="flex flex-col items-center md:mb-8 text-center gap-3 mt-8 mb-8 max-w-md">
      ${eyebrow ? html`<${Eyebrow} text=${eyebrow} />` : ''}
      <h2
        class="h2 leading-none relative self-center ${isNormalCase ? 'normal-case' : ''}"
        dangerouslySetInnerHTML=${{ __html: title }}
      />
      <p class="text-sm md:text-base max-w-[500px] ${isError ? 'text-red-500' : ''}">${description}</p>
      ${descriptionSecondary
        ? html`<p class="text-sm md:text-base max-w-[500px] ${isError ? 'text-red-500' : ''}">
            ${descriptionSecondary}
          </p>`
        : ''}
      ${children}
    </div>
  `;
};

export default Header;
